import React, { Component } from "react";
import { Modal, Button } from "semantic-ui-react";

class ConfirmAction extends Component {
  componentDidMount() {}

  render() {
    return (
      <Modal
        className={"dialog-confirm-action"}
        trigger={this.props.source}
        closeIcon
        open={this.props.active}
        onClose={() => this.props.dialogClose(this)}
      >
        <Modal.Header>{this.props.dialogProps.title}</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>{this.props.dialogProps.body}</Modal.Description>
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <div className={"float-right"}>
            <Button primary onClick={() => this.props.dialogSubmit()}>
              {this.props.dialogProps.comfirmButtonText}
            </Button>
            <Button
              className={"no-background-color"}
              onClick={() => this.props.dialogClose(this)}
            >
              {this.props.dialogProps.cancelButtonText}
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ConfirmAction;



// WEBPACK FOOTER //
// ./src/components/dialogs/ConfirmAction.js